import { render } from "./risk-disclaimer.vue?vue&type=template&id=3697266f"
import script from "./risk-disclaimer.vue?vue&type=script&lang=js"
export * from "./risk-disclaimer.vue?vue&type=script&lang=js"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__